/* VoluFine · boutons « Aggiungi al carrello » du bas de la fiche (sections 11, 12, 14, 17) et surlignages.
   Règle : tout bouton d'offre plus bas dans la page pilote le lot Moon. Au clic :
     1) la page remonte en douceur jusqu'au bloc d'achat (scrollTo, jamais scrollIntoView) ;
     2) si le bouton porte une offre (data-offer = 1, 2…), on coche cette offre dans le bloc Moon ;
     3) on appuie sur le bouton d'achat principal ([data-vf-add]) : un seul appel /cart/add.js, Moon met le lot entier et
        ouvre son panier. Sans bloc d'achat sur la page, rien ne se passe (jamais de 2e méthode d'ajout). */
(function(){
  if(window.__svVfBuy)return; window.__svVfBuy=1;

  function buyRoot(){ return document.querySelector('[data-vf03]')||document.querySelector('form[action*="/cart/add"]:not([id*="rawer"])'); }
  function addButton(){
    return document.querySelector('[data-vf-add]')||
      document.querySelector('form[action*="/cart/add"]:not([id*="rawer"]):not([class*="upsell"]) [type="submit"][name="add"]');
  }
  /* les offres Moon : les cartes les plus extérieures du bloc d'appli */
  function moonOptions(){
    var box=document.querySelector('[data-vf-moon]')||document;
    var list=[].slice.call(box.querySelectorAll('.moonbundle-option-wrapper,.moonbundle-option'));
    return list.filter(function(el){ return !list.some(function(o){ return o!==el&&o.contains(el); }); });
  }
  function isChecked(opt){
    if(/\b(selected|active|checked|is-selected|is-active)\b/.test(opt.className))return true;
    var i=opt.querySelector('input[type="radio"],input[type="checkbox"]'); return !!(i&&i.checked);
  }
  function pick(opt){
    if(isChecked(opt))return;
    opt.click();
    var i=opt.querySelector('input[type="radio"],input[type="checkbox"]');
    if(i&&!i.checked){ i.checked=true; i.dispatchEvent(new Event('change',{bubbles:true})); }
  }
  function headerOffset(){
    var h=0;
    [].slice.call(document.querySelectorAll('header,.shopify-section-group-header-group,[data-sticky-header]')).forEach(function(el){
      var cs=getComputedStyle(el), r=el.getBoundingClientRect();
      if((cs.position==='sticky'||cs.position==='fixed')&&r.top<=1&&r.bottom>0)h=Math.max(h,r.bottom);
    });
    return h+12;
  }
  function run(btn){
    var add=addButton(); if(!add)return;
    var n=parseInt(btn.getAttribute('data-offer')||'0',10)||0;
    var root=buyRoot();
    var target=(root&&root.querySelector&&root.querySelector('[data-vf-moon]'))||add;
    btn.setAttribute('data-busy','');
    var wait=0;
    if(btn.getAttribute('data-scroll')!=='0'&&target){
      var y=target.getBoundingClientRect().top+window.pageYOffset-headerOffset();
      if(Math.abs(y-window.pageYOffset)>4){ window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); wait=650; }
    }
    setTimeout(function(){
      var opts=n>0?moonOptions():[];
      if(n>0&&opts[n-1])pick(opts[n-1]);
      setTimeout(function(){ add.click(); btn.removeAttribute('data-busy'); },(n>0&&opts[n-1])?350:0);
    },wait);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-vf-buy]'); if(!b)return;
    e.preventDefault(); if(b.hasAttribute('data-busy'))return; run(b);
  });

  /* surlignages et soulignements : se dessinent quand ils arrivent à l'écran (comme la source) */
  var pending=[];
  function collect(){
    [].slice.call(document.querySelectorAll('[data-vf-hl]')).forEach(function(el){
      if(el.dataset.hlReady)return; el.dataset.hlReady='1'; el.classList.add('vf-anim'); pending.push(el);
    });
    check();
  }
  function check(){
    var vh=window.innerHeight;
    pending=pending.filter(function(el){ var r=el.getBoundingClientRect(); if(r.top<vh*0.92&&r.bottom>0){ el.classList.add('is-in'); return false; } return true; });
  }
  var t=null;
  window.addEventListener('scroll',function(){ if(!t)t=setTimeout(function(){ t=null; check(); },80); },{passive:true});
  window.addEventListener('resize',check);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){ setTimeout(collect,100); }); else setTimeout(collect,100);
  document.addEventListener('shopify:section:load',collect);
})();
